export function truncateString(text: string, maxLength: number = 50): string {
  if (text.length <= maxLength) return text;

  return text.slice(0, maxLength - 3) + '...';
}

export default truncateString;
